<template>
    <div class="ele-header">
        <div
            :class="{
                headContent: backType == 'blank',
                headContent3: backType == 'gra',
                headContent4: backType == 'none',
                headContent2: backType == 'normal' || !backType,
            }"
        >
            <Svgs
                v-if="false"
                :style="backStyle"
                @click.native="backPath"
                class="backBtn"
                :color="backType == 'normal' ? '#fff' : '#000'"
                name="iconfanhui"
            ></Svgs>
            <!-- <slot name="headText"></slot>
            <div class="rightBtn">
                <slot name="rightBtn"></slot>
            </div> -->
        </div>
    </div>
</template>

<script>
export default {
    name: "Header",
    props: ["back", "backType", "backStyle", "headStyle"],
    methods: {
        backPath() {
            this.$emit("goBack");
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";

.ele-header {
    height: 0.46rem;
}
.headContent,
.headContent2,
.headContent3,
.headContent4 {
    height: 0.47rem;
    line-height: 0.46rem;
    font-size: 0.16rem;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 100;
    font-weight: 500;
    text-align: center;
}

.headContent {
    background-color: #f8f8f8;
    color: #333;
}

.headContent2 {
    background: var(--themeColor);
    color: #fff;
}

.headContent3 {
    background-color: #ffffff;
    color: #333;
}

.backBtn {
    position: absolute;
    left: 0.25rem;
    top: 0.15rem;
}

.rightBtn {
    position: absolute;
    right: 0.25rem;
    top: 0.05rem;
    height: 0.4rem;
    width: 0.8rem;
    text-align: right;
}

.rightBtn div {
    float: right;
}
</style>